import { render, staticRenderFns } from "./MessageMemberView.vue?vue&type=template&id=42bd90a1&scoped=true&"
import script from "./MessageMemberView.vue?vue&type=script&lang=js&"
export * from "./MessageMemberView.vue?vue&type=script&lang=js&"
import style0 from "./MessageMemberView.vue?vue&type=style&index=0&id=42bd90a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd90a1",
  null
  
)

export default component.exports